var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.available_suggestions,
              expression: "!available_suggestions"
            }
          ],
          staticClass: "trp-no-available-suggestions"
        },
        [_vm._v(_vm._s(_vm.editorStrings.translation_memory_no_suggestions))]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "details",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.available_suggestions,
                expression: "available_suggestions"
              }
            ],
            attrs: { open: "open" }
          },
          [
            _c("summary", [
              _vm._v(_vm._s(_vm.editorStrings.translation_memory_suggestions))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trp-translation-memory-suggestions" }, [
              _c(
                "ul",
                _vm._l(_vm.suggestions, function(suggestion, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      attrs: {
                        title:
                          _vm.editorStrings.translation_memory_click_to_copy
                      },
                      on: {
                        click: function($event) {
                          _vm.copy(suggestion.translated)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "percentage" }, [
                        _c("span", [
                          _vm._v(_vm._s(suggestion.similarity) + "%")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "translated" }, [
                        _vm._v(_vm._s(suggestion.translated))
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "original",
                        domProps: { innerHTML: _vm._s(suggestion.original) }
                      })
                    ]
                  )
                }),
                0
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }